import axios from "axios";
import { CHECKLIST_BUILDER_URL } from "../../../../utils/constService";
import { getAuthHeader } from "../../../../../configuration/Utils/constService";

export const fetchBuilders = (params = {}) => axios.get(CHECKLIST_BUILDER_URL, { ...getAuthHeader(), params });
export const fetchBuildersByProductId = (productId) => axios.get(`${CHECKLIST_BUILDER_URL}/get-by-product-id/${productId}`, getAuthHeader());
export const fetchBuilderById = (id) => axios.get(`${CHECKLIST_BUILDER_URL}/${id}`, getAuthHeader());
export const postBuilder = (data) => axios.post(CHECKLIST_BUILDER_URL, data, getAuthHeader());
export const putBuilder = (data, id) => axios.put(`${CHECKLIST_BUILDER_URL}/${id}`, data, getAuthHeader());
export const deleteBuilder = (id) => axios.delete(`${CHECKLIST_BUILDER_URL}/${id}`, getAuthHeader());
